import { render, staticRenderFns } from "./bank-account.vue?vue&type=template&id=27a886c2&scoped=true&"
import script from "./bank-account.vue?vue&type=script&lang=js&"
export * from "./bank-account.vue?vue&type=script&lang=js&"
import style0 from "./bank-account.vue?vue&type=style&index=0&id=27a886c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a886c2",
  null
  
)

export default component.exports